import React, { useEffect } from 'react';
import './modalChurned.css';
import { ReactComponent as Plus } from "../../img/plusToArr.svg";
import { Input } from '../input/input.js';
import { ReactComponent as X } from './x.svg';
import { Button } from '../button/button';
import { ButtonLess } from '../button/buttonLess.jsx';
import { UseOnChange } from '../../utils/onChange.jsx'
function ModalAddedItems(props) {
    const { values, onChange, setValues } = UseOnChange()

    const onChangeArr = (event, index) => {
        const { name, value } = event.target;
        const updatedArray = [...props.added];
    
        if (name === 'ocupacao') {
            updatedArray[index] = { ...updatedArray[index], [name]: value };
        } else {
            updatedArray[index] = { ...updatedArray[index], [name]: value, ocupacao: '' };
        }
        props.setAdded(updatedArray);
    }

    const onButtonClick = (index) => {
        const newPdus = { ...props.pdus };

        if (!newPdus[`pdu${index}`]) {
            newPdus[`pdu${index}`] = [];
        }

        newPdus[`pdu${index}`] = [{ pdu: values.pdu, circuito: values.circuito }, ...newPdus[`pdu${index}`]];
        props.setPdus(newPdus);
        setValues({ pdu: '', circuito: '' });
    };

    const areAllFieldsValid = () => {
        return props.added.every(obj => 
            obj.nscala && 
            obj.potenciaContratada && 
            obj.fileira && 
            obj.posicao
        );
    };

    useEffect(() => {
        console.log("All fields valid:", areAllFieldsValid());
    }, [props.added]);

    return (
        <section className='modal-churned' style={props.open == true ? { display: 'flex' } : { display: 'none' }}>
            <div className='modal-churned-view-count'>
                <div className='title-churned'>
                    <X className='x-churned' onClick={() => props.setOpen(false)} />
                    <h1>Enter the requested information to add racks</h1>
                    <button
                        className="button-to-plus-arr"
                        onClick={() => props.setAdded([...props.added, {}])}
                        type="button"
                    >
                        <Plus className="btn-plus" />
                        Add new rack
                    </button>
                </div>
                <div className='body-racks1'>
                    <div className="row-inputs-technical-group">
                        {props.added.map((obj, index) => (
                            <div className="addedsrows">
                                <div style={{ display: 'flex', flexDirection: 'column', padding: 20, gap: 10 }}>
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                        <h4 className="number-description-tech">New Rack {index + 1}</h4>
                                        <ButtonLess
                                            onClick={() => {
                                                const updatedarr = [...props.added];
                                                updatedarr.splice(index, 1);
                                                props.setAdded(updatedarr);
                                            }}
                                            type='x' />
                                    </div>
                                    <div className="row-inputs-technical-added" key={index}>
                                        <Input
                                            onChange={(e) => onChangeArr(e, index, "added")}
                                            name="nrack"
                                            required={false}
                                            value={obj.nrack}
                                            placeholder='0000'
                                            props={{
                                                minWidth: "unset",
                                                marginRight: 10,
                                            }}
                                            title={"Client Rack Name"}
                                            type="text"
                                        />
                                        <Input
                                            onChange={(e) => onChangeArr(e, index, "added")}
                                            name="nscala"
                                            required={true}
                                            placeholder='0000'
                                            value={obj.nscala}
                                            props={{
                                                minWidth: "unset",
                                                marginRight: 10,
                                            }}
                                            title={"Scala Rack Name"}
                                            type="text"
                                        />
                                        <Input
                                            onChange={(e) => onChangeArr(e, index, "added")}
                                            name="potenciaContratada"
                                            required={true}
                                            placeholder='0'
                                            value={obj.potenciaContratada}
                                            props={{
                                                minWidth: "unset",
                                                marginRight: 10,
                                            }}
                                            title={"Power"}
                                            type="text"
                                        />
                                        <Input
                                            onChange={(e) => onChangeArr(e, index, "added")}
                                            name="fileira"
                                            required={true}
                                            placeholder='Ex: 1'
                                            value={obj.fileira}
                                            props={{
                                                minWidth: "unset",
                                                marginRight: 10,
                                            }}
                                            title={"Row - Y axis"}
                                            type="number"
                                        />
                                        <Input
                                            onChange={(e) => onChangeArr(e, index, "added")}
                                            name="posicao"
                                            required={true}
                                            placeholder='Ex: 1'
                                            value={obj.posicao}
                                            props={{
                                                minWidth: "unset",
                                                marginRight: 10,
                                            }}
                                            title={"Position - X axis"}
                                            type="number"
                                        />
                                        <Input
                                            onChange={(e) => onChangeArr(e, index, "added")}
                                            name="ocupacao"
                                            required={false}
                                            placeholder='600x1050x44U'
                                            value={obj.ocupacao}
                                            props={{
                                                minWidth: "unset",
                                                marginRight: 10,
                                            }}
                                            title={"Occupation"}
                                            type="text"
                                        />
                                        <Input
                                            onChange={(e) => onChangeArr(e, index, "added")}
                                            name="classification"
                                            required={false}
                                            placeholder='Ex: Scala / Edge'
                                            value={obj.classification}
                                            props={{
                                                minWidth: "unset",
                                                marginRight: 10,
                                            }}
                                            title={"Classification"}
                                            type="text"
                                        />
                                    </div>
                                    <div style={{ display: 'flex', gap: 15, alignItems: 'center', width: '100%' }} key={`${index}_2`}>
                                        <Input
                                            onChange={onChange}
                                            name="pdu"
                                            required={false}
                                            value={values.pdu}
                                            placeholder='PDU A.A'
                                            props={{
                                                minWidth: "unset",
                                            }}
                                            style={{ width: '50%' }}
                                            title={"PDU/SDU"}
                                            type="text"
                                        />
                                        <Input
                                            onChange={onChange}
                                            name="circuito"
                                            required={false}
                                            value={values.circuito}
                                            placeholder='0.0.0.0'
                                            props={{
                                                minWidth: "unset"
                                            }}
                                            style={{ width: '50%' }}
                                            title={"Circuit"}
                                            type="text"
                                        />
                                        <ButtonLess
                                            style={{ cursor: !values.pdu && !values.circuito ? 'not-allowed' : 'pointer', marginTop: 17, }} onClick={values.pdu || values.circuito ? () => onButtonClick(index) : null}
                                            type='plus' />

                                    </div>

                                    <div >
                                        {
                                            !!props.pdus[`pdu${index}`] &&
                                                props.pdus[`pdu${index}`]?.map((pdu, indPdu) => {
                                                    return (
                                                        <div style={{ display: 'flex', gap: 15, alignItems: 'center', width: '100%' }} key={indPdu}>
                                                            <Input
                                                                disabled
                                                                required={false}
                                                                value={pdu.pdu}
                                                                props={{
                                                                    border: 'none',
                                                                    background: 'transparent',

                                                                    minWidth: "unset",
                                                                }}
                                                                style={{ width: '50%' }}
                                                                title={"PDU/SDU"}
                                                            />
                                                            <Input
                                                                disabled
                                                                required={false}
                                                                value={pdu.circuito}
                                                                props={{
                                                                    border: 'none',
                                                                    background: 'transparent',

                                                                    minWidth: "unset",
                                                                }}
                                                                style={{ width: '50%' }}
                                                                title={"Circuit"}
                                                            />
                                                            <ButtonLess onClick={() => {
                                                                    const newValue = props.pdus[`pdu${index}`]?.filter(
                                                                        el => !(el.pdu === pdu.pdu && el.circuito === pdu.circuito)
                                                                    );
                                                                    props.setPdus({...props.pdus, [`pdu${index}`]: newValue});
                                                                }}
                                                                type="x"
                                                            />
                                                        </div>
                                                    )
                                                })
                                        }
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className='btns-modal-churned'>
                    <Button
                        onClick={() =>
                            props.setOpen(false)
                        }
                        style={{ width: '48%', marginRight: '5px' }}
                        label={"Cancel"}
                    />
                    <Button onClick={() => {
                        props.setOpen(false);
                    }}
                        style={props.added.length > 0 ? { width: '48%', background: "#0F0742", color: "#fff", marginLeft: '5px' } : { width: '48%', background: "#979797", color: "#fff", marginLeft: '5px', border: 'none' }}
                        label={"Confirm"}
                        disabled={!areAllFieldsValid()}
                    />
                </div>

            </div>
        </section>
    );
}

export default ModalAddedItems;
